import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5002 4.66659H9.91683V3.49992C9.91683 1.88992 8.61016 0.583252 7.00016 0.583252C5.39016 0.583252 4.0835 1.88992 4.0835 3.49992V4.66659H3.50016C2.8585 4.66659 2.3335 5.19159 2.3335 5.83325V11.6666C2.3335 12.3083 2.8585 12.8333 3.50016 12.8333H10.5002C11.1418 12.8333 11.6668 12.3083 11.6668 11.6666V5.83325C11.6668 5.19159 11.1418 4.66659 10.5002 4.66659ZM7.00016 9.91659C6.3585 9.91659 5.8335 9.39159 5.8335 8.74992C5.8335 8.10825 6.3585 7.58325 7.00016 7.58325C7.64183 7.58325 8.16683 8.10825 8.16683 8.74992C8.16683 9.39159 7.64183 9.91659 7.00016 9.91659ZM8.8085 4.66659H5.19183V3.49992C5.19183 2.50242 6.00266 1.69159 7.00016 1.69159C7.99766 1.69159 8.8085 2.50242 8.8085 3.49992V4.66659Z",
		fill: "white"
	})
});
export default SvgLockWhite;
